import * as React from 'react';

import CollectionBolt16 from './CollectionBolt16';

export const collectionBolt16 = () => <CollectionBolt16 />;

export default {
    title: 'Icon|Line|CollectionBolt16',
    component: CollectionBolt16,
    parameters: {
        notes: "`import CollectionBolt16 from 'box-ui-elements/es/icon/line/CollectionBolt16';`",
    },
};
